import { render, staticRenderFns } from "./SimpleApp.vue?vue&type=template&id=00c9f74f&"
import script from "./SimpleApp.vue?vue&type=script&lang=js&"
export * from "./SimpleApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports